import { type Store } from 'effector'
import { useUnit } from 'effector-react'
import type { TFunction } from 'i18next'
import { useCallback } from 'react'

type CallableTranslate = (interpolationKeys?: Record<string, string>) => string

export type TranslationKeys = Record<string, string>
export type PlayerTranslationKeys = Record<string, CallableTranslate>

export const callableTranslate = (
  t: TFunction,
  key: string
): CallableTranslate => {
  return (interpolationKeys) => {
    const translate = t(key, { ...interpolationKeys })

    return translate === key ? '' : translate
  }
}

const createT =
  (obj: Record<string, string>, space?: string) => (key: string) =>
    obj[`${space || ''}${key}`] || key

export const useTranslate = (
  store: Store<Record<string, string>>,
  space?: string
) => {
  const usableStore = useUnit(store)
  const t = useCallback(
    (key: string) => createT(usableStore, space)(key),
    [space, usableStore]
  )

  return { t }
}
